export var TableCellDisplayMode;
(function (TableCellDisplayMode) {
    TableCellDisplayMode["Auto"] = "auto";
    TableCellDisplayMode["ColorText"] = "color-text";
    TableCellDisplayMode["ColorBackground"] = "color-background";
    TableCellDisplayMode["GradientGauge"] = "gradient-gauge";
    TableCellDisplayMode["LcdGauge"] = "lcd-gauge";
    TableCellDisplayMode["JSONView"] = "json-view";
    TableCellDisplayMode["BasicGauge"] = "basic";
    TableCellDisplayMode["Image"] = "image";
})(TableCellDisplayMode || (TableCellDisplayMode = {}));
export var FILTER_FOR_OPERATOR = '=';
export var FILTER_OUT_OPERATOR = '!=';
//# sourceMappingURL=types.js.map